import { render, staticRenderFns } from "./panelEditarBaseFiscalAnt.vue?vue&type=template&id=6b9f48de&"
import script from "./panelEditarBaseFiscalAnt.vue?vue&type=script&lang=js&"
export * from "./panelEditarBaseFiscalAnt.vue?vue&type=script&lang=js&"
import style0 from "./panelEditarBaseFiscalAnt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports